
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Définition d’Inbound Marketing : l’agence ALEO vous l’explique",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez comment l’Inbound Marketing peut attirer des prospects qualifiés, renforcer la confiance et booster vos ventes grâce à des contenus et des expériences personnalisées.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Définition d’Inbound Marketing : l’agence ALEO vous l’explique",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez comment l’Inbound Marketing peut attirer des prospects qualifiés, renforcer la confiance et booster vos ventes grâce à des contenus et des expériences personnalisées.",
        },
      ],
    };
  },
};
